import Cookies from 'js-cookie';

/**
 * @param {string} key - cookie key
 * @param {object} options
 * @param {(value: string) => boolean} options.shouldExtend
 * @param {() => string} options.getNewValue
 * @param {Cookies.CookieAttributes} options.cookieAttributes
 */
export default function extendOrSetCookie(key, options) {
  const oldValue = Cookies.get(key);
  const shouldExtend = options.shouldExtend(oldValue || '');
  const value = shouldExtend ? oldValue : options.getNewValue();

  Cookies.set(key, value, options.cookieAttributes);

  return {
    key,
    value: Cookies.get(key),
    isExtended: shouldExtend,
  };
}
